/* © CNES */
import {
  ACQUISITION_STATION,
  BANDS,
  CLASSIFICATION,
  CLOUD_COVER,
  COUPLING_MODES,
  DATASET,
  DATETIME,
  END_POINT_URL,
  EO_SNOW_COVER,
  GERALD_NAME,
  GRID_CODE,
  INSTRUMENT,
  INSTRUMENT_MODE,
  MISSION,
  MISSION_TAKE_ID,
  ORBIT_ABSOLUTE,
  ORBIT_RELATIVE,
  ORBIT_STATE,
  PARAMETER,
  PLATFORM,
  POLARIZATIONS,
  PPARAMETER,
  PROCESSING_CONTEXT,
  PROCESSING_CORRECTION,
  PROCESSING_DATETIME,
  PROCESSING_FACILITY,
  PROCESSING_LEVEL,
  PROCESSING_LINEAGE,
  PROCESSING_VERSION,
  PROCESSING_WEATHERDATA,
  PRODUCT_ACQUISITION_TYPE,
  PRODUCT_TIMELINESS,
  PRODUCT_TIMELINESS_CATEGORY,
  PRODUCT_TYPE,
  PRODUCT_VALIDITY,
  RASTER_SPATIAL_RESOLUTION,
  RESOLUTION_MODE,
  S2_DATASTRIP_ID,
  S2_DATATAKE_ID,
  S2_DATATAKE_TYPE,
  SAR_BEAM_IDS,
  SAR_CENTER_FREQUENCY,
  SAR_FREQUENCY_BAND,
  SAR_LOOKS_AZIMUTH,
  SAR_LOOKS_EQUIVALENT_NUMBER,
  SAR_LOOKS_RANGE,
  SAR_OBSERVATION_DIRECTION,
  SAR_PIXEL_SPACING_AZIMUTH,
  SAR_PIXEL_SPACING_RANGE,
  SAR_RELATIVE_BURST,
  SAR_RESOLUTION_AZIMUTH,
  SAR_RESOLUTION_RANGE,
  SENSOR_ANGLE,
  SENSOR_PITCH,
  SENSOR_ROLL,
  SWATH,
  SWATH_MODE,
  TEMPORAL_RESOLUTION,
  THEMES,
  VERSION,
  VIEW_AZIMUTH,
  VIEW_INCIDENCE_ANGLE,
  VIEW_OFF_NADIR,
  VIEW_SUN_AZIMUTH,
  VIEW_SUN_ELEVATION,
  VISIBILITY,
  WATER_COVER,
} from '../Constants';

export const mappingProductAttributes = [
  { key: PLATFORM, label: 'Platform' },
  { key: PARAMETER, label: 'Parameter' },
  { key: PPARAMETER, label: 'P-parameter' },
  { key: PROCESSING_LEVEL, label: 'Processing level' },
  { key: GRID_CODE, label: 'Tile ID' },
  { key: PRODUCT_TYPE, label: 'Type of product' },
  { key: CLOUD_COVER, label: 'Cloud cover' },
  { key: EO_SNOW_COVER, label: 'Snow cover' },
  { key: WATER_COVER, label: 'Water cover' },
  { key: ORBIT_STATE, label: 'Orbit direction' },
  { key: ORBIT_ABSOLUTE, label: 'Absolute orbit number' },
  { key: ORBIT_RELATIVE, label: 'Relative orbit number' },
  { key: BANDS, label: 'Bands' },
  { key: S2_DATATAKE_ID, label: 'Datatake ID' },
  { key: S2_DATATAKE_TYPE, label: 'Datatake type' },
  { key: S2_DATASTRIP_ID, label: 'Datastrip ID' },
  { key: VIEW_INCIDENCE_ANGLE, label: 'Incidence angle' },
  { key: VIEW_AZIMUTH, label: 'Azimuth' },
  { key: VIEW_SUN_AZIMUTH, label: 'Sun azimuth' },
  { key: VIEW_SUN_ELEVATION, label: 'Sun elevation' },
  { key: VIEW_OFF_NADIR, label: 'Off nadir' },
  { key: SWATH, label: 'Swath' },
  { key: SWATH_MODE, label: 'Swath mode' },
  { key: DATETIME, label: 'GEODES publishing date' },
  { key: PRODUCT_TIMELINESS, label: 'Product timeliness' },
  { key: PRODUCT_TIMELINESS_CATEGORY, label: 'Timeliness category' },
  { key: PRODUCT_ACQUISITION_TYPE, label: 'Acquisition type' },
  { key: PROCESSING_CONTEXT, label: 'Processing context' },
  { key: PROCESSING_CORRECTION, label: 'Processing correction' },
  { key: PROCESSING_DATETIME, label: 'Processing date' },
  { key: PROCESSING_LINEAGE, label: 'Processing mode' },
  { key: PROCESSING_VERSION, label: 'Processing version' },
  { key: INSTRUMENT, label: 'Instrument' },
  { key: INSTRUMENT_MODE, label: 'Sensor mode' },
  { key: POLARIZATIONS, label: 'Polarizations' },
  { key: COUPLING_MODES, label: 'Coupling modes' },
  { key: SAR_FREQUENCY_BAND, label: 'Frequency band' },
  { key: SAR_CENTER_FREQUENCY, label: 'Frequency center' },
  { key: SAR_RESOLUTION_RANGE, label: 'Range resolution' },
  { key: SAR_RESOLUTION_AZIMUTH, label: 'Azimuth resolution' },
  { key: SAR_PIXEL_SPACING_RANGE, label: 'Range pixel spacing' },
  { key: SAR_PIXEL_SPACING_AZIMUTH, label: 'Azimuth pixel spacing' },
  { key: SAR_LOOKS_RANGE, label: 'Range looks' },
  { key: SAR_LOOKS_AZIMUTH, label: 'Azimuth looks' },
  { key: SAR_LOOKS_EQUIVALENT_NUMBER, label: 'Equivalent looks' },
  { key: SAR_OBSERVATION_DIRECTION, label: 'Observation direction' },
  { key: SAR_RELATIVE_BURST, label: 'Relative burst' },
  { key: SAR_BEAM_IDS, label: 'Beam ids' },
  { key: SENSOR_ANGLE, label: 'Sensor angle' },
  { key: SENSOR_PITCH, label: 'Sensor pitch' },
  { key: SENSOR_ROLL, label: 'Sensor roll' },
  { key: RASTER_SPATIAL_RESOLUTION, label: 'Spatial resolution' },
  { key: TEMPORAL_RESOLUTION, label: 'Temporal resolution' },
  { key: RESOLUTION_MODE, label: 'Resolution mode' },
  { key: MISSION_TAKE_ID, label: 'Mission take ID' },
  { key: GERALD_NAME, label: 'Gerald name' },
  { key: ACQUISITION_STATION, label: 'Acquisition station' },
  { key: CLASSIFICATION, label: 'Classification' },
  { key: THEMES, label: 'Themes' },
  { key: PROCESSING_FACILITY, label: 'Processing facility' },
  { key: MISSION, label: 'Project' },
  { key: PROCESSING_WEATHERDATA, label: 'Weather data' },
  { key: VERSION, label: 'Version' },
  { key: PRODUCT_VALIDITY, label: 'Product validity' },
  { key: END_POINT_URL, label: 'Storage location' },
  { key: DATASET, label: 'Data type' },
  { key: VISIBILITY, label: 'Access right' },
];

export const EXCLUDED_DYNAMIC_KEYS = new Set([
  'stac_version',
  'stac_extensions',
  'id',
  'bbox',
  'proj:bbox',
  'type',
  'collection',
  'latest',
  'references',
  'identifier',
  'area',
  'endpoint_description',
  'continent_code',
  'political',
  'links',
  'assets',
  'proj:centroid',
  'proj:geometry',
  'geometry',
  'proj:code',
  'proj:wkt2',
  'proj:projjson',
  'proj:shape',
  'proj:transform',
  'providerDisseminationDate',
  's2:tile_id',
  's2:product_uri',
  'sci:doi',
  'sci:citation',
  'sci:publications',
  'published',
  'expired',
  'unpublished',
  'nodata_pixel',
  'saturated_defective_pixel',
  'ground_useful_pixel',
  'min_useful_pixel',
  'start_datetime',
  'end_datetime',
  'created',
  'updated',
  'keywords',
  'data_type',
  'nodata',
  'thumbnail',
  'product',
  'subtitle',
  'nb_col_interpolation_error',
  'nb_cols',
  'nb_rows',
  'nb_bands',
  'gain_number',
  'no_geometry',
]);
